/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { BlockquoteBlockDataContent } from './BlockquoteBlockDataContent'
import {
  BlockquoteBlockDataContentFromJSON,
  BlockquoteBlockDataContentFromJSONTyped,
  BlockquoteBlockDataContentToJSON,
} from './BlockquoteBlockDataContent'

/**
 *
 * @export
 * @interface BlockquoteBlockData
 */
export interface BlockquoteBlockData {
  /**
   *
   * @type {BlockquoteBlockDataContent}
   * @memberof BlockquoteBlockData
   */
  content: BlockquoteBlockDataContent
}

/**
 * Check if a given object implements the BlockquoteBlockData interface.
 */
export function instanceOfBlockquoteBlockData(
  value: object
): value is BlockquoteBlockData {
  if (!('content' in value) || value['content'] === undefined) return false
  return true
}

export function BlockquoteBlockDataFromJSON(json: any): BlockquoteBlockData {
  return BlockquoteBlockDataFromJSONTyped(json, false)
}

export function BlockquoteBlockDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BlockquoteBlockData {
  if (json == null) {
    return json
  }
  return {
    content: BlockquoteBlockDataContentFromJSON(json['content']),
  }
}

export function BlockquoteBlockDataToJSON(
  value?: BlockquoteBlockData | null
): any {
  if (value == null) {
    return value
  }
  return {
    content: BlockquoteBlockDataContentToJSON(value['content']),
  }
}
